(function () {
  if (window.__superBonsaiGlobalLocalization) return;
  window.__superBonsaiGlobalLocalization = true;

  var copy = {
    nl: {
      homeBenefits: ['7 botanische ingrediënten', '30 dagelijkse porties', 'Eenvoudige dagelijkse vloeibare routine'],
      pdpBenefits: ['100% VEGAN', '100% plantaardige extracten', '100% glutenvrij'],
      iconBar: [
        ['Gratis snelle verzending', 'Gratis verzending vanaf €39. Je bestelling wordt zorgvuldig voorbereid en met tracking verzonden.'],
        ['Veilig betalen', 'Betaal via een beveiligde betaalomgeving met vertrouwde betaalmethoden.'],
        ['Klantenservice', 'Vragen over je bestelling of product? Ons team helpt je graag.'],
        ['60 dagen geld-terug-garantie', 'Probeer SuperBonsai met de zekerheid van onze vrijwillige 60-dagen-garantie.']
      ]
    },
    de: {
      homeBenefits: ['7 botanische Inhaltsstoffe', '30 Tagesportionen', 'Einfache tägliche Flüssigroutine'],
      pdpBenefits: ['100% VEGAN', '100% pflanzliche Extrakte', '100% glutenfrei'],
      iconBar: [
        ['Kostenloser schneller Versand', 'Kostenloser Versand ab €39. Deine Bestellung wird sorgfältig vorbereitet und mit Sendungsverfolgung verschickt.'],
        ['Sicher bezahlen', 'Bezahle über eine sichere Checkout-Umgebung mit vertrauenswürdigen Zahlungsmethoden.'],
        ['Kundenservice', 'Fragen zu deiner Bestellung oder zum Produkt? Unser Team hilft dir gerne.'],
        ['60 Tage Geld-zurück-Garantie', 'Teste SuperBonsai mit der Sicherheit unserer freiwilligen 60-Tage-Garantie.']
      ]
    },
    en: {
      homeBenefits: ['7 botanical ingredients', '30 daily servings', 'Simple daily liquid routine'],
      pdpBenefits: ['100% VEGAN', '100% plant-based extracts', '100% gluten-free'],
      iconBar: [
        ['Free fast shipping', 'Free shipping from €39. Your order is carefully prepared and shipped with tracking.'],
        ['Secure payment', 'Pay through a secure checkout environment with trusted payment methods.'],
        ['Customer support', 'Questions about your order or product? Our team is here to help.'],
        ['60-day money-back guarantee', 'Try SuperBonsai with the reassurance of our voluntary 60-day guarantee.']
      ]
    }
  };

  function locale() {
    var code = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return copy[code] ? code : 'en';
  }

  function isGermanHomepage() {
    var host = (window.location.hostname || '').toLowerCase();
    var germanHost = host === 'superbonsai.de' || host.endsWith('.superbonsai.de');
    return germanHost && document.body.classList.contains('template-index');
  }

  function rowLabel(row) {
    if (!row) return null;
    var children = row.children || [];
    for (var i = children.length - 1; i >= 0; i--) {
      var child = children[i];
      if (child.tagName === 'SPAN' && !child.classList.contains('material-symbols-outlined') && !child.classList.contains('sb-pdp-check-box')) return child;
    }
    return row.lastElementChild;
  }

  function setRows(container, values) {
    if (!container) return;
    var rows = container.querySelectorAll('.product__text');
    for (var i = 0; i < Math.min(rows.length, values.length); i++) {
      var label = rowLabel(rows[i]);
      if (label) label.textContent = values[i];
    }
  }

  function forceCheckboxIcons(container) {
    if (!container) return;
    container.querySelectorAll('.product__text').forEach(function (row) {
      var label = rowLabel(row);
      if (!label) return;
      while (row.firstElementChild && row.firstElementChild !== label) row.removeChild(row.firstElementChild);
      var icon = document.createElement('span');
      icon.className = 'sb-pdp-check-box';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><rect x="3.5" y="3.5" width="17" height="17" rx="1.5" fill="currentColor"></rect><path d="M7.2 12.2l3.1 3.1 6.6-7" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      row.insertBefore(icon, label);
    });
  }

  function localizeGermanHomepageCtas() {
    if (!isGermanHomepage()) return;
    document.querySelectorAll('.multirow a.button, .multirow button.button').forEach(function (button) {
      var label = (button.textContent || '').trim().toLowerCase();
      if (label === 'discover super liver') button.textContent = 'Super Liver entdecken';
    });
  }

  function apply() {
    var activeLocale = locale();
    var t = copy[activeLocale];

    document.querySelectorAll('.section-featured-product .product__text-container').forEach(function (container) {
      setRows(container, t.homeBenefits);
      if (isGermanHomepage()) forceCheckboxIcons(container);
    });

    localizeGermanHomepageCtas();

    if (document.body.classList.contains('template-product--superbonsai')) {
      document.querySelectorAll('.product__info-container .product__text-container').forEach(function (container) {
        var text = (container.textContent || '').toLowerCase();
        if (text.indexOf('vegan') !== -1 || text.indexOf('plantaardige extracten') !== -1 || text.indexOf('pflanzliche extrakte') !== -1 || text.indexOf('plant-based extracts') !== -1) {
          setRows(container, t.pdpBenefits);
          forceCheckboxIcons(container);
        }
      });
    }

    document.querySelectorAll('.icon-bar').forEach(function (bar) {
      var cards = bar.querySelectorAll('.icon-bar-card');
      for (var i = 0; i < Math.min(cards.length, t.iconBar.length); i++) {
        var heading = cards[i].querySelector('h3');
        var text = cards[i].querySelector('.rte');
        if (heading) heading.textContent = t.iconBar[i][0];
        if (text) text.innerHTML = '<p>' + t.iconBar[i][1] + '</p>';
      }
    });
  }

  function applyWithRetry() {
    apply();
    window.setTimeout(apply, 300);
    window.setTimeout(apply, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyWithRetry);
  else applyWithRetry();
  document.addEventListener('shopify:section:load', applyWithRetry);
})();
